"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  vesselMovement: {
    title: 'Vessel Movement',
    vesselName: 'Vessel Name',
    tips_1: 'Result',
    tips_2: 'Black font：',
    tips_3: 'Estimated time',
    tips_4: 'Blue font：',
    tips_5: 'Coastal schedule',
    tips_6: 'Red font：',
    tips_7: 'Actual time',
    tips_8: 'Updated at 10:00, 13:00, 16:00. However, for Japan ports below URL is more accurate.',
    vesselNameShort: 'Vessel Name',
    voyage: 'VOY',
    port: 'Port',
    terminal: 'Terminal',
    originalETA: 'Original ETA',
    originalETB: 'Original ETB',
    originalETD: 'Original ETD',
    eta: 'ETA(ATA)',
    etb: 'ETB(ATB)',
    etd: 'ETD(ATD)',
    rate: 'Rate',
    remark: 'Remark',
    updateTime: 'Update Date',
    lastMonth: '◀ Previous Month  |',
    nextMonth: '  Next Month ▶'
  }
};